import { createAction } from '../../../../../store.model';
import { ActionType } from '../transcript-summary.action';

export interface ToggleCategoryTranscript {
    transcriptId: number;
    isOpen: boolean;
    expandParent?: boolean;
}

export const toggleCategoryTranscript = createAction<
    ActionType,
    ToggleCategoryTranscript
>(ActionType.COACHING_DETAIL__TS__TOGGLE_CATEGORY_TRANSCRIPT);
